<div *ngIf="loading" class="text-center mt-5">
  <app-loader></app-loader>
</div>

<div *ngIf="!loading && org">
  <div class="hero" [ngStyle]="{ backgroundColor: org.appSettings.themeColor }">
    <div class="container h-100">
      <div class="row align-items-center">
        <div class="col">
          <h1>{{ org.name }}</h1>
          <p [innerHTML]="org.descriptionRendered"></p>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row my-5" id="events">
      <div class="col">
        <h2 class="mb-3">Upcoming Events</h2>

        <div class="row">
          <div
            class="col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="
              let event of events | sortDate: 'startDate':'asc';
              index as i
            "
          >
            <app-event-card [event]="event"></app-event-card>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-5" id="events">
      <div class="col">
        <h2 class="mb-3">Past Events</h2>

        <div class="row">
          <div
            class="col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="
              let event of pastEvents | sortDate: 'endDate':'desc';
              index as i
            "
          >
            <app-event-card [event]="event"></app-event-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-not-found
  *ngIf="!loading && !org"
  text="The organization you're looking for could not be found!"
></app-not-found>
